import React from 'react'
import PropTypes from 'prop-types'

import { PHONE_PLACEHOLDER } from 'utils/constants/defaultValues'
import { Row } from 'components/grid/Row'
import { Col } from 'components/grid/Col'
import { Text } from 'components/text/Text'
import { FormInput } from 'components/form/input/FormInput'
import { FormInputPhone } from 'components/form/inputPhone/FormInputPhone'

import styles from './EmployerInfo.module.scss'
import { formTypes } from 'utils/constants/formTypes'

const InfoTextByForm = ({ type }) => {
  switch (type) {
    case formTypes.NM_EMPLOYMENT_REFERENCE:
      return (
        <>
          <Text size={16} weight="bold" color="greyBlue" display="block">
            Authorized Person Information:
          </Text>
          <Text size={14} color="greyBlue">
            I attest, under penalty of perjury, that to the best of my knowledge, this information is true.
          </Text>
        </>
      )
    default:
      return (
        <Text size={14} color="greyBlue">
          Please check your info as submitted by an applicant.
        </Text>
      )
  }
}

InfoTextByForm.propTypes = {
  type: PropTypes.string.isRequired,
}

export const EmployerInfo = ({ formData, handleFieldChange, type }) => (
  <div className={styles.employerInfo}>
    <Row bottomIndent>
      <Col size={12}>
        <InfoTextByForm type={type} />
      </Col>
    </Row>

    <Row bottomIndent>
      <Col size={4}>
        <FormInput
          title="First Name"
          placeholder="First Name"
          field={formData.employerFirstName}
          onChange={handleFieldChange(`employerFirstName`)}
        />
      </Col>
      <Col size={4}>
        <FormInput
          title="Last Name"
          placeholder="Last Name"
          field={formData.employerLastName}
          onChange={handleFieldChange(`employerLastName`)}
        />
      </Col>
      <Col size={4}>
        <FormInput
          title="Email"
          placeholder="Email"
          field={formData.employerEmail}
          onChange={handleFieldChange(`employerEmail`)}
        />
      </Col>
    </Row>

    <Row>
      <Col size={4}>
        <FormInput
          title="Title"
          placeholder="Title"
          field={formData.employerTitle}
          onChange={handleFieldChange(`employerTitle`)}
        />
      </Col>
      <Col size={4}>
        <FormInputPhone
          title="Phone"
          placeholder={PHONE_PLACEHOLDER}
          field={formData.employerPhone}
          onChange={handleFieldChange(`employerPhone`)}
        />
      </Col>
    </Row>
  </div>
)

EmployerInfo.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
}
